<div class="dropdown mt2" onclick="this.classList.toggle('active')">
  <div class="dropdown-toggle dropdown-down">{{ selected }}&nbsp;▼</div>
  <div class="dropdown-toggle dropdown-up">{{ selected }}&nbsp;▲</div>
  <div class="dropdown-menu">
    <div *ngFor="let country of countries" (click)="change(country.code)">{{ country.code }}</div>
  </div>
</div>
